export default "__VITE_ASSET__Ddtdhbci__"